'use strict';

angular.module('formonlineApp').service('FrontendlogService', ['$http',
    function ($http) {

        var getStackTrace = function(error) {
            var stack = error.stack || '';
            stack = stack.split('\n').map(function (line) { return line.trim(); });
            return stack.join('\n');
        };

        this.logCaptcha = function (captcha, error, successFn, errorFn) {
            var data = {
                captcha: captcha,
                log: getStackTrace(error)
            };

            return $http({
                method: 'post',
                url: 'api/frontendlog/captcha',
                data: data
            }).success(successFn).error(errorFn);
        };

        this.logWhitelist = function (ndc, annee, codeSecurite, error, successFn, errorFn) {
            var data = {
                ndc: ndc,
                annee: annee,
                codeSecurite: codeSecurite,
                formType: 'DECLARIS',
                log: getStackTrace(error)
            };

            return $http({
                method: 'post',
                url: 'api/frontendlog/whitelist',
                data: data
            }).success(successFn).error(errorFn);
        };

    }]);
